import { gql } from 'graphql-request';

const UpdateAnnotationSetMutation = gql`
  mutation UpdateAnnotationSet(
    $story_id: ID
    $style_font_size: Int
    $style_show_order_indicators: Boolean
  ) {
    update_annotation_set(
      story_id: $story_id
      style_font_size: $style_font_size
      style_show_order_indicators: $style_show_order_indicators
    ) {
      __typename

      ... on annotation_set {
        id
        target_chart_dataset_column
        updated_at

        style {
          show_order_indicators
          font_size
        }
      }

      ... on i_error {
        message
      }
    }
  }
`;

export default UpdateAnnotationSetMutation;
